import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

/**
 * Marker painted over a frame/clip tile that already has a rework queued — a big red
 * X plus a label, so the producer doesn't flag the same asset twice while waiting.
 */
export default function ReworkPendingOverlay() {
  const { t } = useTranslation('production');
  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center rounded bg-red-600/20">
      <X className="h-12 w-12 text-red-500 drop-shadow" strokeWidth={3.5} />
      <span className="rounded bg-red-600/90 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white">
        {t('tile.reworkQueued')}
      </span>
    </div>
  );
}
